<template>
    <div class="success-page-wrapper">
      <div class="success-page-wrapper__img-holder">
        <img src="@/assets/images/briefumschlag.svg" class="success-page-wrapper__img" alt="Letter">
      </div>
      <h3 class="success-page-wrapper__title">{{ ($t('successPage.title')) }}</h3>

      <p class="success-page-wrapper__par">{{ ($t('successPage.description')) }} <br>
        <span>{{ userData.email }}</span>
      </p>
    </div>
</template>

<script>
export default {
  props: {
    userData: Object
  },
  setup (userData) {
  }
}
</script>

<style lang="scss" scoped>
    .success-page-wrapper {
      margin-top: calc(var(--spacing-xl) * 3 + var(--spacing-s));
      margin-bottom: calc(var(--spacing-xl) * 3 + var(--spacing-s));
      margin-left: 0;
      margin-right: 0;

      @include respond-to('medium') {
        padding-top: calc(var(--spacing-xl) * 2 + var(--spacing-xs));
      }

      &__img-holder {
        max-width: 120px;
        margin: auto;
        margin-bottom: calc(var(--spacing-s) + var(--spacing-xl));

        @include respond-to('small') {
          max-width: 176px;
          margin-bottom: calc(var(--spacing-xl) * 3);
        }
      }
      &__img {
        width: 100%;
      }
      &__title {
        @include form-title;
        margin-bottom: var(--spacing-l);

        @include respond-to('small') {
          margin-bottom: calc(var(--spacing-xl) * 2);
        }
      }
      &__par {
        // Include the base font properties
        @include font-properties-base(var(--fontsize-s), var(--fontweight-regular), normal);

        // Include the tablet font properties
        @include font-properties-tablet(var(--fontsize-m), var(--fontweight-regular), normal);
      }
      &__link {
        margin-top: var(--spacing-l);
        text-decoration: underline;
      }
    }
</style>
